import Config from "../global/Config.js"

class VersionDisplay {
	constructor() {
		let container = document.createElement("div")
		container.setAttribute("id", "version-display")
		container.textContent = "v" + Config.version
		document.body.appendChild(container)
	}
}

export default VersionDisplay
